import { LoadingSpinner } from './LoadingSpinner';

export function MetricsLoadingSpinner() {
  return (
    <div role="progressbar" className="xl:col-span-12 col-span-6 flex items-center justify-center h-48 w-full">
      <LoadingSpinner />
    </div>
  );
}
